import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { HistoryMergerBasedByMin } from './HistoryMergerBasedByMin';
export class HistoryMergerExtraday extends HistoryMergerBasedByMin {
    GetStartPoint(dateTimeUtc) {
        // aggregation from start point Jan 1 1970
        const unixEpoch = DateTimeUtils._ZeroTime;
        const borders = this.GetPropagatedBarBorders(dateTimeUtc, unixEpoch, this.newPeriod);
        return borders;
    }
}
